module.exports = __webpack_public_path__ + "static/img/shoplist.e2f07b2c.png";